import posthogClient from "posthog-js";

export const DEFAULT_SESSION_REPLAY_SAMPLE_RATE = 0.00075;

const SESSION_REPLAY_OVERRIDE = {
  sampling: true,
  linked_flag: true,
  url_trigger: true,
  event_trigger: true,
} as const;

export function getSessionReplaySampleRate(value = import.meta.env.VITE_POSTHOG_SESSION_REPLAY_SAMPLE_RATE): number {
  if (!value?.trim()) return DEFAULT_SESSION_REPLAY_SAMPLE_RATE;

  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 && parsed <= 1 ? parsed : DEFAULT_SESSION_REPLAY_SAMPLE_RATE;
}

export function shouldSampleSessionReplay(sessionId: string, sampleRate: number): boolean {
  if (sampleRate <= 0) return false;
  if (sampleRate >= 1) return true;

  let hash = 2166136261;
  for (let index = 0; index < sessionId.length; index += 1) {
    hash = Math.imul(hash ^ sessionId.charCodeAt(index), 16777619);
  }

  return (hash >>> 0) / 2 ** 32 < sampleRate;
}

/** Force recording for the current session, bypassing every remote replay gate. */
export function startSessionReplay(): void {
  posthogClient.startSessionRecording(SESSION_REPLAY_OVERRIDE);
}
